import { SearchMaskMountOptions } from '@webc/meeseeks-ui-sdk';
import { CmsApi } from 'app/api/cmsApi';

export const UPDATE_OPTIONS = 'UPDATE_OPTIONS';
export type UpdateOptionsAction = {
  type: typeof UPDATE_OPTIONS;
  options: SearchMaskMountOptions;
};
export const updateOptions = (options: SearchMaskMountOptions): UpdateOptionsAction => ({
  type: UPDATE_OPTIONS,
  options,
});

export const REQUEST_SEARCH = 'REQUEST_SEARCH';
export type RequestSearchAction = {
  type: typeof REQUEST_SEARCH;
};
export const requestSearch = (): RequestSearchAction => ({
  type: REQUEST_SEARCH,
});

export const TOGGLE_FEATURE = 'TOGGLE_FEATURE';
export type ToggleFeatureAction = {
  type: typeof TOGGLE_FEATURE;
  name: string;
  value: boolean;
};
export const toggleFeature = (name: string, value: boolean): ToggleFeatureAction => ({
  type: TOGGLE_FEATURE,
  name,
  value,
});

export const SET_CMS_API_INSTANCE = 'SET_CMS_API_INSTANCE';
export type SetCmsApiInstanceAction = {
  type: typeof SET_CMS_API_INSTANCE;
  cmsApiInstance: CmsApi;
};
export const setCmsApiInstance = (cmsApiInstance: CmsApi): SetCmsApiInstanceAction => ({
  type: SET_CMS_API_INSTANCE,
  cmsApiInstance,
});

export type GeneralActions =
  | UpdateOptionsAction
  | RequestSearchAction
  | ToggleFeatureAction
  | SetCmsApiInstanceAction;
